import { defineStore } from 'pinia';
import { pcCardAssetLogList } from '@/api/wallet';

function normalizeText(value) {
  if (value === null || value === undefined) {
    return '';
  }
  const text = String(value).trim();
  if (!text || text.toLowerCase() === 'null' || text.toLowerCase() === 'undefined') {
    return '';
  }
  return text;
}

function pickFirstValue(record, keys = []) {
  for (const key of keys) {
    const value = normalizeText(record?.[key]);
    if (value) {
      return value;
    }
  }
  return '';
}

function normalizeWalletBillRecord(record = {}) {
  const addOrSubAmount = pickFirstValue(record, ['addOrSubAmount', 'changeAmount', 'amountChange']) || '0';
  const amount = pickFirstValue(record, ['amount', 'addOrSubAmount', 'changeAmount', 'amountChange']) || '0';
  const symbol = pickFirstValue(record, ['symbol', 'coin']);
  const coin = pickFirstValue(record, ['coin', 'symbol']);
  const type = pickFirstValue(record, ['type']) || (Number(addOrSubAmount) > 0 ? 'in' : 'out');

  return {
    ...record,
    symbol,
    coin,
    type,
    amount,
    addOrSubAmount,
    time: pickFirstValue(record, ['time', 'createTime', 'createTimeStr']),
    fromAddress: pickFirstValue(record, ['fromAddress', 'from', 'addressFrom', 'fromAddr', 'sender', 'sourceAddress']),
    toAddress: pickFirstValue(record, ['toAddress', 'to', 'addressTo', 'toAddr', 'receiver', 'targetAddress']),
    hash: pickFirstValue(record, ['hash', 'txHash', 'transactionHash', 'tradeHash']),
    chainName: pickFirstValue(record, ['chainName', 'network', 'networkName', 'symbolType']),
    chainImg: pickFirstValue(record, ['chainImg', 'networkImg', 'chainLogo', 'symbolTypeImg']),
    explorerUrl: pickFirstValue(record, ['explorerUrl', 'scanUrl', 'browserUrl', 'txUrl']),
    logLevelMsg: pickFirstValue(record, ['logLevelMsg', 'remark', 'detail']),
    img: pickFirstValue(record, ['img', 'logo', 'symbolImg'])
  };
}

function defaultState() {
  return {
    list: [],
    loading: false,
    finished: false,
    pageNum: 1,
    pageSize: 10,
    currentTrade: null
  };
}

export const useWalletBillStore = defineStore('wallet-bill', {
  state: () => defaultState(),
  actions: {
    reset() {
      Object.assign(this, defaultState());
    },
    setCurrentTrade(trade) {
      this.currentTrade = trade ? normalizeWalletBillRecord(trade) : null;
    },
    async fetchNext({ address, reset = false } = {}) {
      if (reset) {
        this.reset();
      }

      if (this.loading || this.finished) {
        return this.list;
      }

      this.loading = true;
      try {
        const result = await pcCardAssetLogList({
          address: address || null,
          pageNum: this.pageNum,
          pageSize: this.pageSize
        });
        const rows = Array.isArray(result?.list) ? result.list.map((item) => normalizeWalletBillRecord(item)) : [];
        this.list = this.pageNum === 1 ? rows : [...this.list, ...rows];
        this.finished = rows.length === 0;
        if (rows.length > 0) {
          this.pageNum += 1;
        }
        return this.list;
      } finally {
        this.loading = false;
      }
    }
  }
});
